//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import stateList from '../../assets/src/usstates.json'
import moment from 'moment'

export default {
    data() {
        return {
            activeState: null,
            activeCity: null,
            activeLocation: null,
            state: null,
            states: [],
            count: null,
            abbr: null
        }
    },
    methods: {
        slug(str) {
            return str.replace(/ /g, '-').toLowerCase()
        },
        // unSlug(str) {
        //     return str.replace(/-/g, ' ').split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')
        // },
        unSlug(str) {
            return str.replace(/-/g, ' ')
        },
        abbrToState(abbr) {
            abbr = abbr.toUpperCase()
            return stateList[abbr]
        },
        goTo(path) {
            this.$router.push('/locations/' + path)
        },
        getStateIndex(state, states) {
            let index = -1
            states.map((s, i) => {
                if (s.abbr == state) {
                    index = i
                }
            })
            return index
        },
        getCityIndex(city, cities) {
            let index = -1
            cities.map((c, i) => {
                if (c.name == city) {
                    index = i
                }
            })
            return index
        },
        hours(loc) {
            let hours = loc.hours[new Date().getDay()]
            if (hours !== undefined) {
                let time = moment(hours.date + ' ' + hours.close, 'YYYY-MM-DD H:mm').format('h a')
                if (loc.closed) {
                    return 'Opens at ' + time
                } else {
                    return 'Open until ' + time
                }
            }
        },
        sortStates(a, b) {
            return a.abbr < b.abbr ? -1 : 1
        },
        sortCities(a, b) {
            return a.name < b.name ? -1 : 1
        },
        async startOrder(loc) {
            let location = await this.$api.getLocation(loc.id)
            if (location) {
                await this.$api.getMenu()
                let order = null
                if (this.order) {
                    order = await this.$api.transferOrder()
                    if (!order) {
                        order = await this.$api.setHandoff('pickup')
                    }
                    if (order && order.totals.tip > 0) {
                        await this.$api.addTip(0)
                    }
                } else {
                    order = await this.$api.createOrder()
                }
                if (order) {
                    if (this.method == 'delivery') {
                        let order2 = await this.$api.setAddress(this.$store.state.customer.delivery)
                        if (order2) {
                            this.$router.push('/order/')
                        }
                    } else {
                        await this.$api.setHandoff('pickup')
                        this.$router.push('/order/')
                    }
                }
            }
        }
    },
    computed: {
        ...mapState(['allLocations', 'options']),
        cities() {
            let cities = []
            let abbr = ''
            for (let i = 0; i < this.states.length; i++) {
                abbr = this.states[i].abbr
                if (this.states[i].abbr == 'Puerto Rico') {
                    abbr = 'PR'
                }
                abbr = abbr.toLowerCase()
                if (abbr == this.activeState) {
                    cities = this.states[i].cities
                    break
                }
            }
            return cities
        },
        cards() {
            for (var i = 0; i < this.cities.length; i++) {
                if (this.cities[i].name == this.activeCity) {
                    return this.cities[i].locations
                    break
                }
            }
        }
    },
    mounted() {
        let parts = this.$route.path.split('/')
        if (parts[2] && parts[2] !== 'view-all') {
            this.activeState = parts[2].toLowerCase()
        }
        if (parts[3]) {
              this.activeCity = this.unSlug(parts[3].toLowerCase()) 
            // this.activeCity = parts[3].toLowerCase()
        }

        let states = []
        this.allLocations.map(l => {
            let stateAbbr = l.state
            if (stateAbbr == 'Puerto Rico') {
                stateAbbr = 'PR'
            }
            let stateIndex = this.getStateIndex(stateAbbr, states)
            if (stateIndex < 0) {
                states.push({
                    abbr: stateAbbr,
                    name: stateList[stateAbbr],
                    cities: [],
                    locationsCount: 0,
                })
                stateIndex = states.length - 1
            }
            let cityIndex = this.getCityIndex(l.city.toLowerCase(), states[stateIndex].cities)
            if (cityIndex < 0) {
                states[stateIndex].cities.push({
                    //   name: l.city,
                    name: l.city.toLowerCase(),
                    locations: []
                })
                cityIndex = states[stateIndex].cities.length - 1
            }
            states[stateIndex].cities[cityIndex].locations.push(l)
        })
        states.forEach(state => {
            // console.log(state.cities)
            state.cities.forEach(city => {
                state.locationsCount += city.locations.length
            })
        })
        states.map(s => {
            s.cities.sort(this.sortCities)
        })
        states.sort(this.sortStates)
        this.states = states
    }
}
